module.exports = __webpack_public_path__ + "static/media/splashfinacc.c800cd9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/splashfinacc.svg
// module id = 56
// module chunks = 0